var _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriftLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "450 335 140 105",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sunset",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E27B58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DE7783"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 461.633 412.282 L 569.777 412.282 L 556.259 427.282 L 475.151 427.282 L 461.633 412.282 Z",
    fill: "url(#sunset)",
    stroke: "black",
    strokeLinejoin: "round",
    style: {
      strokeWidth: 5
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 512.925,
    y: 343.109,
    width: 5.78,
    height: 69.83,
    fill: "black",
    rx: 3,
    ry: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 509.982 350.665 C 489.885 370.665 476.183 390.665 467.048 405.665 L 509.982 405.665 L 509.982 350.665 Z",
    strokeWidth: 1,
    strokeLinejoin: "round",
    style: {
      fill: "rgb(252, 187, 109)",
      stroke: "rgb(252, 187, 109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 521.648 350.142 C 541.744 370.142 555.447 390.142 564.581 405.142 L 521.648 405.142 L 521.648 350.142 Z",
    strokeWidth: 1,
    strokeLinejoin: "round",
    style: {
      stroke: "rgb(216, 115, 127)",
      fill: "rgb(216, 115, 127)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriftLogo);
export default __webpack_public_path__ + "static/media/drift_logo.906ab9231b102105e3ed94e4fd28ede0.svg";
export { ForwardRef as ReactComponent };